import { render } from "./CompareSC.vue?vue&type=template&id=9fc9fcc0&scoped=true"
import script from "./CompareSC.vue?vue&type=script&lang=js"
export * from "./CompareSC.vue?vue&type=script&lang=js"

import "./CompareSC.vue?vue&type=style&index=0&id=9fc9fcc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fc9fcc0"]])

export default __exports__